import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faCoins,
  faGavel,
  faCheckCircle,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

export default function ListingPage() {
  const { id } = useParams();
  const [listing, setListing] = useState(null);

  useEffect(() => {
    console.log("fetching listing id: ", id);
    fetch(`${process.env.REACT_APP_API_URL_PROD}/api/listings/${id}`)
      .then((response) => response.json())
      .then((data) => setListing(data));
  }, [id]);

  if (!listing) {
    return <div>Loading details for {id}...</div>;
  }

  return (
    <div>
      <Container style={{ marginTop: "5%", marginBottom: "5%" }}>
        <img src={listing.logo_url} style={{ width: "20%" }}></img>
        <h1 style={{ fontWeight: "lighter" }}>{listing.name}</h1>
        <br></br>
        <h3>
          <FontAwesomeIcon icon={faBook}></FontAwesomeIcon> About
        </h3>
        <Card className="listing-detail-card">
          <p style={{ color: "green" }}>
            <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon> Verified
            developer
          </p>
          <p>
            {" "}
            Risk Rating:{" "}
            <span style={{ color: "orange" }}>
              <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>
              <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>
              <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>
              <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>
              <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>{" "}
            </span>
          </p>
          <p>{listing.description}</p>
          <p>{listing.details}</p>
          <img
            src={listing.detail_image_url}
            style={{ width: "20%", borderRadius: "15px" }}
          ></img>
          <br></br>
          <a
            href={listing.website}
            target="_blank"
            style={{
              textDecoration: "none",
              color: "#2b96ed",
              fontWeight: 600,
            }}
          >
            Learn More
          </a>
        </Card>

        <h3>
          <FontAwesomeIcon icon={faCoins}></FontAwesomeIcon>Available tax
          credits
        </h3>

        <Card className="listing-detail-card">
          {" "}
          <p>{listing.credits}</p>
          <p>{listing.credit_amount}</p>
          <p> Available {listing.credit_availability}</p>
        </Card>

        <Button className="btn-hover color-1">
          <FontAwesomeIcon icon={faGavel}></FontAwesomeIcon> Make an offer to{" "}
          {listing.name}
        </Button>
      </Container>
    </div>
  );
}
